import { push } from "connected-react-router";
import * as Cookies from "js-cookie";
import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { selectRouterSegment } from "@tsp-shared/connect-router";

import { UserStateData, useStatus } from "../../user";

import { ACCESS_PAGE_COOKIE_NAME } from "../interface";

interface Props {
  checkAccess: (data: UserStateData) => boolean;
}

// Логика предоставления доступа
export const useAccess = (props: Props) => {
  const dispatch = useDispatch();
  const { checkAccess } = props;
  const [access, setAccess] = useState(false);
  const {
    location: { pathname, search },
  } = useSelector(selectRouterSegment);

  const redirectUri = `${pathname}${search}`;

  const onComplete = useCallback(
    (data: UserStateData) => {
      const access = checkAccess(data);

      if (access) {
        setAccess(access);
      } else {
        // TODO: Move to localStorage later
        Cookies.set(ACCESS_PAGE_COOKIE_NAME, redirectUri);
        dispatch(push("/auth"));
      }
    },
    [checkAccess, dispatch, redirectUri],
  );

  const loading = useStatus({ onComplete });

  return [loading, access];
};
